// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__by8yp","footer":"ModalInfo_footer__3zo6V"};